import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import {
    onChangeCompetitorsZonesChangesOperatorsFilter,
    onChangeCompetitorsZonesChangesPeriod,
    onChangeCompetitorsZonesChangesTypeFilter,
} from '../../../ac/onChangeMapFilters';
import { functionalAreasYandexUrentTypes } from '../../../constants/variables';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { DynamicAttributeFilter } from '../DynamicAttributeFilter';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const PERIOD_OPTIONS = [
    { value: 7, label: '7 дней' },
    { value: 14, label: '14 дней' },
    { value: 30, label: '30 дней' },
];
const OPERATORS_TYPES = functionalAreasYandexUrentTypes.filter(t => t.value !== 'SmartBike'); // без SmartBike (нет истории изменений); Yandex, Urent, Jet, Lime, Bolt, Voi
const CompetitorsZonesChangesComponent = ({
    mapFilters,
    onChangeCompetitorsZonesChangesOperatorsFilter,
    onChangeCompetitorsZonesChangesPeriod,
    onChangeCompetitorsZonesChangesTypeFilter,
}) => {
    const {
        competitorsZonesChangesPeriod,
        competitorsZonesChangesAvailableOperators,
        competitorsZonesChangesOperatorsDisabled,
        competitorsZonesChangesDisabledTypes,
    } = mapFilters;
    const disabledTypes = competitorsZonesChangesDisabledTypes || [];
    const renderTypeIcon = (strokeColor, fillColor, dashed = false, indented = false, extraStyle = {}) => (
        <svg
            viewBox="0 0 32 24"
            aria-hidden="true"
            style={{ marginLeft: indented ? 10 : 0, ...extraStyle }}
        >
            <rect
                x="2"
                y="2"
                width="28"
                height="20"
                fill={fillColor}
                stroke={strokeColor}
                strokeWidth="2.5"
                strokeOpacity="0.9"
                rx="2"
                strokeDasharray={dashed ? '6 3' : null}
            />
        </svg>
    );

    return (
        <div>
            {/* Фильтр периода изменений */}
            <div className={styles.legHead}>{t`Период изменений`}:</div>
            <StandardRadioGroup
                value={competitorsZonesChangesPeriod}
                onChange={onChangeCompetitorsZonesChangesPeriod}
            >
                {PERIOD_OPTIONS.map(({ value, label }) => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={competitorsZonesChangesPeriod === value}
                                onChange={onChangeCompetitorsZonesChangesPeriod}
                                value={value}
                                className={classnames(styles.isochroneFilterInput, {
                                    [styles.checkedIsochroneFilterInput]: competitorsZonesChangesPeriod === value,
                                })}
                                size="small"
                            />
                        }
                        label={label}
                        labelPlacement="end"
                    />
                ))}
            </StandardRadioGroup>

            {/* Фильтр операторов */}
            <DynamicAttributeFilter
                title={t`Операторы`}
                attributeTypes={OPERATORS_TYPES}
                availableValues={competitorsZonesChangesAvailableOperators}
                disabledValues={competitorsZonesChangesOperatorsDisabled}
                onToggle={onChangeCompetitorsZonesChangesOperatorsFilter}
                inputNamePrefix="competitors-zones-changes-operator"
            />

            {/* Типы изменений с переключателями */}
            <div className={styles.legHead}>{t`Тип изменения`}:</div>
            <div className={classnames(styles.checkboxIconGrid, styles.checkboxIconGridLarge)}>

                {/* Новая зона */}
                {renderTypeIcon('#22c55e', 'rgba(34,197,94,0.3)')}
                <label htmlFor="czc-new">{t`Новая зона`}</label>
                <div>
                    <label className={styles.switch}>
                        <input
                            type="checkbox"
                            id="czc-new"
                            name="competitorsZonesChangesType"
                            value="new"
                            checked={!disabledTypes.includes('new')}
                            onChange={onChangeCompetitorsZonesChangesTypeFilter}
                        />
                        <span className={classnames(styles.sliderRound, styles.slider)} />
                    </label>
                </div>

                {/* Зона удалена */}
                {renderTypeIcon('#ef4444', 'rgba(239,68,68,0.3)')}
                <label htmlFor="czc-deleted">{t`Зона удалена`}</label>
                <div>
                    <label className={styles.switch}>
                        <input
                            type="checkbox"
                            id="czc-deleted"
                            name="competitorsZonesChangesType"
                            value="deleted"
                            checked={!disabledTypes.includes('deleted')}
                            onChange={onChangeCompetitorsZonesChangesTypeFilter}
                        />
                        <span className={classnames(styles.sliderRound, styles.slider)} />
                    </label>
                </div>

                {/* Изменены атрибуты */}
                {renderTypeIcon('#ffffff', 'rgba(255,255,255,0.1)')}
                <label htmlFor="czc-attrs">{t`Изменены атрибуты`}</label>
                <div>
                    <label className={styles.switch}>
                        <input
                            type="checkbox"
                            id="czc-attrs"
                            name="competitorsZonesChangesType"
                            value="attrs_changed"
                            checked={!disabledTypes.includes('attrs_changed')}
                            onChange={onChangeCompetitorsZonesChangesTypeFilter}
                        />
                        <span className={classnames(styles.sliderRound, styles.slider)} />
                    </label>
                </div>

                {/* Геометрия изменена — подзаголовок + один тоггл */}
                <span />
                <span style={{ fontSize: '13px', marginTop: '4px' }}>{t`Геометрия изменена`}</span>
                <div>
                    <label className={styles.switch}>
                        <input
                            type="checkbox"
                            id="czc-geom"
                            name="competitorsZonesChangesType"
                            value="geom_changed"
                            checked={!disabledTypes.includes('geom_changed')}
                            onChange={onChangeCompetitorsZonesChangesTypeFilter}
                        />
                        <span className={classnames(styles.sliderRound, styles.slider)} />
                    </label>
                </div>

                {/* Новый контур (sub-item, без тоггла) */}
                {renderTypeIcon('#f97316', 'rgba(249,115,22,0.3)', false, false, { marginTop: '8px' })}
                <label style={{ marginTop: '8px' }}>{t`Новый контур`}</label>
                <span style={{ marginTop: '8px' }} />

                {/* Старый контур (sub-item, пунктир, без тоггла) */}
                {renderTypeIcon('#fbbf24', 'none', true, false, { marginTop: '8px' })}
                <label style={{ marginTop: '8px' }}>{t`Старый контур`}</label>
                <span style={{ marginTop: '8px' }} />
            </div>
        </div>
    );
};
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(
    mapStateToProps,
    {
        onChangeCompetitorsZonesChangesOperatorsFilter,
        onChangeCompetitorsZonesChangesPeriod,
        onChangeCompetitorsZonesChangesTypeFilter,
    }
)(CompetitorsZonesChangesComponent);

export const CompetitorsZonesChangesFilter = withDisplayedLayersCheck(
    ConnectedComponent,
    'Изменения зон (конкуренты)'
);
